import { useEffect, useState } from 'react';

import { Flex } from "@chakra-ui/react";
import DsrPostTextAreaInput from '../../forms/TextareaField/components/DsrPostTextAreaInput';
import { isValidArray } from '../../global/helpers/global-helpers';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function EditDsrPostInputModal({
  handleCloseModal,
  handleUpdatePostContent,
  dsrId,
  showDsrModalLoader,
  modalTransferPayload
}) {

  const postObjectState = modalTransferPayload?.postObject || null
  const [showOptionsForImages, setShowOptionsForImages] = useState(false)

  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (postObjectState) {
      const { images } = postObjectState || {};
      if (isValidArray(images)) {
        if (images?.length > 0) {
          setShowOptionsForImages(true)
          setFiles(images)
        }
      }
    }
  }, [postObjectState])


  return (
    <LaunchdeckModal
      title={'Edit post'}
      handleCloseModal={handleCloseModal}
      showModal={true}
      // maxW='45em'
    >
      <Flex justify='center' w='100%' mt='1em'>
        <Flex w="100%" align="center">
          <DsrPostTextAreaInput
            userActionRequired='edit-dsr-message-post'
            name="editDsrPostContent"
            sublabel=""
            fontSize='0.875em'
            htmlFor="editDsrPostContent"
            onClickEditPost={handleUpdatePostContent}
            currentValue={postObjectState?.postContent}
            dsrId={dsrId}
            postId={modalTransferPayload?.postIdToEdit}
            originalPostType={postObjectState?.postType}
            postTagProperties={postObjectState?.taggedUsers}
            handleCloseWithoutAction={handleCloseModal}
            isLoading={showDsrModalLoader}
            containsImages={showOptionsForImages}
            imageArray={files}
          />
        </Flex>
      </Flex>

    </LaunchdeckModal>
  )
}
